const REST_HOME_STEP_GENERAL_DATA_VALUE = 'GENERAL_DATA';
const REST_HOME_STEP_GENERAL_DATA_TEXT = 'Dados gerais';
export const REST_HOME_GENERAL_DATA_STEP = {
	id: REST_HOME_STEP_GENERAL_DATA_VALUE,
	text: REST_HOME_STEP_GENERAL_DATA_TEXT
};
export const REST_HOME_STEPS = [
	REST_HOME_GENERAL_DATA_STEP
];
